export const SQUARE_HORIZONTAL_ITEM = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.SquareHorizontalItemElement';
export const CIRCLE_HORIZONTAL_ITEM = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.CircleHorizontalItemElement';
export const RECTANGLE_HORIZONTAL_ITEM = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.RectangleHorizontalItemElement';
export const PODCAST_SQUARE_HORIZONTAL_ITEM = 'Podcast.Web.WidgetsInterface.PodcastSquareHorizontalItemElement';
